import { useClient } from '../App'

/** Heading for a project-scoped page: project name eyebrow + section title. */
export function ProjectHeading({
  projectId,
  title,
}: {
  projectId: string
  title: string
}): JSX.Element {
  const { projects } = useClient()
  const project = projects.find((p) => p.id === projectId)
  return (
    <div className="page-heading">
      <p className="eyebrow">{project?.display_name ?? 'Project'}</p>
      <h1>{title}</h1>
    </div>
  )
}
